import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("footer", { style: {"margin-top":"15px","font-size":"8pt"} }, [
  /*#__PURE__*/_createElementVNode("span", null, "Estonian Language Word Training Interface | Alpha 0.3 © 2022"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode("Thanks for word examples "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://eki.ee",
      style: {"text-decoration":"none"}
    }, "Eesti Keele Instituudi")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WordTraining = _resolveComponent("WordTraining")!
  const _component_training_settings = _resolveComponent("training-settings")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_WordTraining, {
        "enter-button-pressed-count": _ctx.enterButtonPressedCount,
        "chosen-word-number": _ctx.chosenWordNumber
      }, null, 8, ["enter-button-pressed-count", "chosen-word-number"]),
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createVNode(_component_training_settings)
    ]),
    _hoisted_6
  ], 64))
}